export default __webpack_public_path__ + "static/media/sending_invoice.e55f3c54.png";